import Headroom from 'headroom.js'
import SmoothScroll from 'smooth-scroll'

/**
 * Global Header functionality.
 * @author Dayne Coulson-Hoffacker
 */
export default class GlobalHeader {
  /**
   * Constructs a new Global Header instance.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   */
  constructor (options) {
    this.element = options.element
    this.hurdler = options.hurdler
    this.scroll = new SmoothScroll()
    this.scrollOptions = { speed: 1000, easing: 'easeOutCubic', offset: 50 }

    // Hurdler
    this.hurdler.addHurdle({
      test: element => {
        return element.tagName === 'SECTION'
      },
      onJump: element => {
        this.scroll.animateScroll(element, element, this.scrollOptions)
      }
    })

    // headroom
    let headroom = new Headroom(this.element, {
      "offset": 150,
      "tolerance": 5,
      "classes": {
        "initial": "animated",
        "pinned": "slideDown",
        "unpinned": "shrunk"
      }
    })
    headroom.init()
  }
}



// WEBPACK FOOTER //
// ./components/global-header/index.js